// Debe coincidir con IA_DOCS_PAUSADA en el servidor.
export const IA_DOCS_PAUSADA = false;
